import './FacebookCandidatesReview.scss';

import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { api } from '../../utils/api';

export default function FacebookCandidatesReview() {
  const [candidates, setCandidates] = useState([]);
  const [page, setPage]             = useState(1);
  const [hasMore, setHasMore]       = useState(true);
  const perPage = 10;

  useEffect(() => {
    const fetchCandidates = async () => {
      try {
        const { data } = await api.get(`/candidate_job_postings?source=user_submission&page=${page}&per_page=${perPage}`);

        if (page === 1) {
          setCandidates(data);
        } else {
          setCandidates(prev => [...prev, ...data]);
        }

        if (data.length < perPage) {
          setHasMore(false);
        }
      } catch (err) {
        console.error('Error fetching facebook candidates:', err);
      }
    };

    fetchCandidates();
  }, [page]);

  const label = async (id, valid) => {
    setCandidates(prevCandidates =>
      prevCandidates.map(candidate =>
        candidate.id === id ? { ...candidate, valid: valid } : candidate
      )
    );

    api.put(`/candidate_job_postings/${id}`, {valid});
  };

  return (
    <div className='__facebook_candidates_review'>
      <div className='content'>
        <div className='header'>
          <div className='primary'>
            Facebook Candidates
          </div>
        </div>

        <div className='bottom-section'>
          <div className='search-results'>
            {candidates.map((candidate) => (
              <div key={candidate.id} className='job-card'>
                <div className='job-header'>
                  <div className='job-title'>{candidate.title}</div>
                </div>

                {candidate.tags && candidate.tags.trim() !== '' && (
                  <div className='tags'>
                    {candidate.tags.split(',').map((tag, idx) => (
                      <div key={idx} className='tag'>
                        {tag.trim()}
                      </div>
                    ))}
                  </div>
                )}

                {candidate.budget &&
                  <div className='budget'>Budget: ${candidate.budget}</div>
                }

                <div className='body'>{candidate.description}</div>
                {candidate.post_url &&
                  <div className='post-url'>
                    <a href={candidate.post_url} rel="noopener noreferrer" target="_blank">{candidate.post_url}</a>
                  </div>
                }
                <div className='location'><FontAwesomeIcon icon={faLocationDot} /> {candidate.location}</div>
                <div className='label'>
                  <button className={classNames('ppy-btn', {'undecided': candidate.valid === null}, {'green': candidate.valid === true})} onClick={() => label(candidate.id, true)}>
                    Yes
                  </button>
                  <button className={classNames('ppy-btn', {'undecided': candidate.valid === null}, {'ppy-btn-primary': candidate.valid === false})} onClick={() => label(candidate.id, false)}>
                    No
                  </button>
                </div>
                <div className="dates">
                  {candidate.posted_at &&
                    <div>Posted {new Date(candidate.posted_at).toLocaleDateString('en-US')}</div>
                  }
                  { candidate.expires_at &&
                    <div className="expires-at">
                      <div>Expires {new Date(candidate.expires_at).toLocaleDateString('en-US')}</div>
                      {new Date(candidate.expires_at) < new Date() && (
                        <div className="expired">Expired</div>
                      )}
                    </div>
                  }
                </div>
              </div>
            ))}
          </div>
        </div>
        {hasMore && candidates.length > 0 && (
          <div className="load-more">
            <button
              className="ppy-btn ppy-btn-primary"
              onClick={() => setPage(prev => prev + 1)}
            >
              Load More
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
